import React from "react";
import {
  Button,
  Flex,
  Heading,
  Divider,
  Text,
  Card,
} from "@aws-amplify/ui-react";
import FlexFormContainer from "../common/FlexFormContainer";
import { StorageImage } from "@aws-amplify/ui-react-storage";
import { useHRImagingAndLabsMediaQuery } from "./api/useImagingAndLabsQuery";
import { useNavigate, useParams } from "react-router-dom";
import ImageComponent from "../common/ImageComponent";
import { getUrl } from "aws-amplify/storage";

const videoExtensions = ["mp4", "mov", "avi", "wmv"];

const getSignedUrl = async (path) => {
  const result = await getUrl({
    path: path,
    options: {
      validateObjectExistence: false,
    },
  });
  return result.url;
};

export default function ImagingAndLabsPreviewPage() {
  const navigate = useNavigate();
  const params = useParams();
  const [previewFile, setPreviewFile] = React.useState("");
  const [signedUrl, setSignedUrl] = React.useState("");

  React.useEffect(() => {
    if (previewFile) {
      getSignedUrl(previewFile).then((url) => setSignedUrl(url));
    }
  }, [previewFile]);

  const {
    data: mediaResults,
    isPending,
    error,
    isSuccess,
    isFetching,
  } = useHRImagingAndLabsMediaQuery(params.id);

  if (isPending) return "Loading...";

  if (error) return "An error has occurred: " + error.message;

  if (isSuccess)
    return (
      <>
        <div>{isFetching ? "Updating..." : ""}</div>

        <FlexFormContainer headerTitle={params.name}>
          <Flex gap="12" direction="row">
            <Button
              variation="primary"
              size="small"
              onClick={() => {
                navigate("/user/hr/documents");
              }}
            >
              Back to Documents
            </Button>
            <Button
              variation="primary"
              size="small"
              onClick={() => {
                navigate(`/user/hr/documents/${params.id}/edit`);
              }}
            >
              Edit Documents
            </Button>
          </Flex>
          <Flex direction="row">
            <Flex direction="column">
              <>
                {previewFile !== "" &&
                  videoExtensions.includes(previewFile?.split(".")?.pop()) && (
                    <video
                      controls
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "300px",
                        minWidth: "400px",
                      }}
                      src={signedUrl}
                    ></video>
                  )}
              </>
              <>
                {previewFile !== "" &&
                  !videoExtensions.includes(previewFile?.split(".")?.pop()) && (
                    <StorageImage
                      path={`${previewFile}`}
                      alt="preview image"
                      maxHeight="300px"
                      minWidth="300px"
                      validateObjectExistence={true}
                    />
                  )}
              </>
            </Flex>
          </Flex>
          <Flex direction="column">
            <Heading level="6" children="Click to view preview attachment"></Heading>
            {mediaResults.length > 0 &&
              mediaResults?.map((media) => {
                return (
                  <>
                    <Card
                      key={media.id}
                      style={{ padding: "0px", width: "100%" }}
                    >
                      <Button
                        variation="link"
                        onClick={() => {
                          setPreviewFile(media.url);
                        }}
                        style={{
                          cursor: "pointer",
                          padding: "0px 12px 0px 12px",
                          width: "100%",
                        }}
                      >
                        <ImageComponent />
                        <Flex
                          direction="column"
                          alignItems="flex-start"
                          justifyContent="flex-start"
                          gap={1}
                        >
                          <Text
                            as="span"
                            fontSize="12px"
                            style={{ marginLeft: "12px" }}
                          >
                            {media.name}
                          </Text>

                          <Text
                            as="span"
                            fontSize="12px"
                            style={{ marginLeft: "12px" }}
                          >
                            Type:{" "}
                            {media?.url?.split(".")?.pop() === "mp4"
                              ? "Video"
                              : "Image"}
                          </Text>
                        </Flex>
                      </Button>
                    </Card>
                    <Divider
                      width="unset"
                      height="1px"
                      shrink="0"
                      alignSelf="stretch"
                      size="small"
                      orientation="horizontal"
                      style={{ marginTop: "0px" }}
                    ></Divider>
                  </>
                );
              })}

            {mediaResults.length === 0 && (
              <Text
                fontSize="12px"
                style={{
                  marginTop: "10px",
                  marginLeft: "10px",
                  marginBottom: "10px",
                }}
              >
                No attachments found.
              </Text>
            )}
          </Flex>
        </FlexFormContainer>
      </>
    );
}
